"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _DocumentParser = _interopRequireDefault(require("./DocumentParser"));

var _classnames = _interopRequireDefault(require("classnames"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function isKeyboardEvent(event) {
  if ((0, _typeof2.default)(event) !== 'object' || event === null) return false;
  if ((0, _typeof2.default)(event.target) !== 'object' || event.target === null) return false;
  return 'value' in event.target;
}

var TranslationForm = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(TranslationForm, _Component);

  var _super = _createSuper(TranslationForm);

  function TranslationForm(props) {
    var _this;

    (0, _classCallCheck2.default)(this, TranslationForm);
    _this = _super.call(this, props);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      cssClass: 'live-edit__form'
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "textInput", null);
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPhraseGetStart", function () {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          cssClass: 'live-edit__form loading'
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onPhraseGetEnd", function (state) {
      var _this$textInput;

      _this.setState(_objectSpread(_objectSpread({}, state), {}, {
        cssClass: 'live-edit__form active'
      }));

      (_this$textInput = _this.textInput) === null || _this$textInput === void 0 ? void 0 : _this$textInput.focus();
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onTranslateEnd", function (state) {
      _this.setState(_objectSpread(_objectSpread({}, state), {}, {
        cssClass: 'live-edit__form done'
      }));
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleClose", function () {
      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          cssClass: 'live-edit__form'
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleSubmit", function (e) {
      e.preventDefault();

      _this.setState(function (prevState) {
        return _objectSpread(_objectSpread({}, prevState), {}, {
          cssClass: 'live-edit__form sending'
        });
      }, function () {
        _DocumentParser.default.translate(_this.state);
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleChange", function (e) {
      if (!isKeyboardEvent(e)) return;

      _this.setState(function (prevState) {
        var _e$target;

        return _objectSpread(_objectSpread({}, prevState), {}, {
          translation: e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value
        });
      });
    });
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "handleKeyDown", function (e) {
      if (!isKeyboardEvent(e)) return;

      if (e.keyCode === 27) {
        _this.handleClose();
      }
    });
    _this.onPhraseGetStart = _this.onPhraseGetStart.bind((0, _assertThisInitialized2.default)(_this));
    _this.onPhraseGetEnd = _this.onPhraseGetEnd.bind((0, _assertThisInitialized2.default)(_this));
    _this.onTranslateEnd = _this.onTranslateEnd.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleClose = _this.handleClose.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleSubmit = _this.handleSubmit.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleChange = _this.handleChange.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  } // interface for DocumentParser


  (0, _createClass2.default)(TranslationForm, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      if (this.props.liveEdit) {
        _DocumentParser.default.init(function () {
          return _this2.onPhraseGetStart();
        }, function (state) {
          return _this2.onPhraseGetEnd(state);
        }, function (state) {
          return _this2.onTranslateEnd(state);
        });

        document.addEventListener('keydown', this.handleKeyDown);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.liveEdit) {
        _DocumentParser.default.exit();
      }

      document.removeEventListener('keydown', this.handleKeyDown);
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var selectedLocale = this.props.selectedLocale;
      var _this$state = this.state,
          cssClass = _this$state.cssClass,
          category = _this$state.category,
          message = _this$state.message,
          translation = _this$state.translation;
      return (0, _preact.h)("form", {
        className: cssClass
      }, (0, _preact.h)("button", {
        type: "button",
        onClick: function onClick() {
          return _this3.handleClose();
        },
        className: (0, _classnames.default)('btn--cta', 'btn--close', 'icon--cross'),
        title: "Hide panel (<esc>)"
      }), (0, _preact.h)("label", null, (0, _preact.h)("strong", null, "Category"), " ", (0, _preact.h)("em", null, category), " - ", (0, _preact.h)("strong", null, "Phrase"), " ", (0, _preact.h)("em", null, message)), (0, _preact.h)("div", {
        className: "live-edit__form__inputs"
      }, selectedLocale && (0, _preact.h)("div", {
        className: "live-edit__form__language-container"
      }, (0, _preact.h)("div", {
        className: "live-edit__form__language"
      }, selectedLocale.replace('_', '-'))), (0, _preact.h)("input", {
        type: "text",
        value: translation,
        ref: function ref(input) {
          _this3.textInput = input;
        },
        onChange: function onChange(event) {
          return _this3.handleChange(event);
        }
      }), (0, _preact.h)("button", {
        type: "submit",
        onClick: function onClick(event) {
          return _this3.handleSubmit(event);
        },
        className: "btn--cta",
        title: "Save (<enter>)"
      }, "Save")));
    }
  }]);
  return TranslationForm;
}(_preact.Component);

exports.default = TranslationForm;